// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Kit } from './kit';
import { ProductTypeConfigProduct } from './product-type-config-product';

/// <code-import> Place custom imports between <code-import> tags
import { KitDetailPriceInfo, ProductFns } from '@core';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class KitDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  __kitDetailPriceInfo?: KitDetailPriceInfo;
  getPriceInfo(forceRefresh: boolean = false) {
    if (this.__kitDetailPriceInfo == null || forceRefresh) {
      this.__kitDetailPriceInfo = ProductFns.getKitDetailPriceInfo(this);
    }
    return this.__kitDetailPriceInfo;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK kit */
  kitId!: string;
  /** Decimal */
  overrideKitUnitPriceAmt?: number;
  /** Guid FK productTypeConfigProduct */
  productTypeConfigProductId!: string;
  /** Int32 */
  quantity!: number;
  /** Binary */
  rowVersion!: any;
  /** FK kitId */
  kit!: Kit;
  /** FK productTypeConfigProductId */
  productTypeConfigProduct!: ProductTypeConfigProduct;
}

